export default "__VITE_ASSET__DMz_WMX2__"